
import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { Router, RouterEvent } from 'aurelia-router';
import MetisMenu from 'metismenujs';
import { DialogService } from 'aurelia-dialog';
import { AuthService } from 'pages/login/service';

@inject(Router, EventAggregator, DialogService, AuthService)
export class Sidebar {
    constructor(router, ea, dialogService, authService) {
        this.router = router;
        this.dialogService = dialogService;
        this.authService = authService;

        this.quoteSetupRoutes = [
            { route: 'bill-of-material', title: 'Bill of Material' },
            { route: 'customers', title: 'Customers' },
            { route: 'parts', title: 'Parts' },
            { route: 'plants', title: 'Plants' },
            { route: 'projects', title: 'Projects' },
            { route: 'purchase-item-prices', title: 'Purchase Item Prices' },
            { route: 'purchase-type-rules', title: 'Purchase Type Rules' }
        ];

        this.standardSetupRoutes = [
            { route: 'customer-projects', title: 'Customer Project' },
            { route: 'machines', title: 'Machines' },
            { route: 'part-sizes', title: 'Part Sizes' },
            { route: 'processes', title: 'Processes' },
            { route: 'standards', title: 'Standards' },
            { route: 'standard-modifiers', title: 'Standard Modifiers'}
        ];

        this.systemFieldRoutes = [
            { route: 'coatings', title: 'Coatings' },
            { route: 'commodities', title: 'Commodities' },
            { route: 'materials', title: 'Materials' },
            { route: 'purchase-part-types', title: 'Purchase Part Types' },
            { route: 'snapshot-types', title: 'Snapshot Types' },
            { route: 'specific-gravities', title: 'Specific Gravities' },
            { route: 'stages', title: 'Stages' },
            { route: 'statuses', title: 'Status' },
            { route: 'unit-of-measurements', title: 'Unit of Measurements' }
        ];

        this.diatariRoutes = [
            { route: 'assigned-projects', title: 'Assigned Projects' },
            { route: 'daiatari-report', title: 'Daiatari Report' }
        ];

        this.updateRoutes = [
            { route: 'sga-profit-freeze', title: 'Freeze SGA & Profit' }
        ];

        this.toolsRoutes = [
            { route: 'user-manager', title: 'User Manager' }
        ];

        ea.subscribe(RouterEvent.Complete, event => {
            this.quoteSetupMenuActive = this.quoteSetupRoutes.some(x => x.route === event.instruction.config.name || x.route === event.instruction.config.parent);
            this.standardSetupMenuActive = this.standardSetupRoutes.some(x => x.route === event.instruction.config.name || x.route === event.instruction.config.parent);
            this.systemFieldMenuActive = this.systemFieldRoutes.some(x => x.route === event.instruction.config.name || x.route === event.instruction.config.parent);
            this.diatariMenuActive = this.diatariRoutes.some(x => x.route === event.instruction.config.name || x.route === event.instruction.config.parent);
            this.updateMenuActive = this.updateRoutes.some(x => x.route === event.instruction.config.name || x.route === event.instruction.config.partent);
            this.toolsMenuActive = this.toolsRoutes.some(x => x.route === event.instruction.config.name || x.route === event.instruction.config.parent);
        });
    }

    attached() {
        this.mm = new MetisMenu('#side-menu');
        this.initLeftMenuCollapse();
    }

    initLeftMenuCollapse() {
        const currentSIdebarSize = document.body.getAttribute("data-sidebar-size");
        $("#vertical-menu-btn").on("click", function (event) {
            event.preventDefault();
            $("body").toggleClass("sidebar-enable");
            if ($(window).width() >= 992) {
                if (currentSIdebarSize == null) {
                    document.body.getAttribute("data-sidebar-size") == null ||
                        document.body.getAttribute("data-sidebar-size") == "lg" ?
                        document.body.setAttribute("data-sidebar-size", "sm") :
                        document.body.setAttribute("data-sidebar-size", "lg");
                } else if (currentSIdebarSize == "md") {
                    document.body.getAttribute("data-sidebar-size") == "md" ?
                        document.body.setAttribute("data-sidebar-size", "sm") :
                        document.body.setAttribute("data-sidebar-size", "md");
                } else {
                    document.body.getAttribute("data-sidebar-size") == "sm" ?
                        document.body.setAttribute("data-sidebar-size", "lg") :
                        document.body.setAttribute("data-sidebar-size", "sm");
                }
            }
        });

        if (
            $("#sidebar-menu").length > 0 &&
            $("#sidebar-menu .mm-active .active").length > 0
          ) {
            const activeMenu = $("#sidebar-menu .mm-active .active").offset().top;
            if (activeMenu > 300) {
              activeMenu = activeMenu - 300;
              $(".vertical-menu .simplebar-content-wrapper").animate({
                  scrollTop: activeMenu,
                },
                "slow"
              );
            }
          }
    }

    rawMaterialExport() {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('pages/utilities/exports/raw-material-export/index') });
    }

    processExport() {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('pages/utilities/exports/process-export/index') });
    }

    purchasePartExport() {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('pages/utilities/exports/purchase-part-export/index') });
    }

    rawMaterialImport() {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('pages/utilities/imports/raw-material-import/index') });
    }

    scrapPriceUpdate() {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('pages/utilities/imports/scrap-price-update/index') });
    }

    scrapOverrideExport() {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('pages/utilities/exports/scrap-override-export/index') });
    }

    scrapOverrideImport() {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('pages/utilities/imports/scrap-override-import/index') });
    }

    resetSandbox() {
        if (this.authService.user.roleName !== 'ADMIN') return;
        this.dialogService.open({ viewModel: PLATFORM.moduleName('pages/utilities/tools/reset-sandbox/index') });
    }
}
